import { computed, defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { numberFormat } from '@/utils/helpers';
import { TransactTypes } from '@/types/transact';
import router from '@/router';
import useTransactionsStore from '../../store/modules/transactions';
export default defineComponent({
    name: 'TransactHeader',
    props: {
        title: {
            type: String,
            default: '',
            required: false,
        },
        action: {
            type: String,
            default: 'Buying',
            required: false,
        },
        goBack: {
            type: Function,
            default: () => console.log(''),
            required: false,
        },
        showHome: {
            type: Boolean,
            default: false,
            required: false,
        },
        backNavigation: {
            type: Boolean,
            default: true,
            required: false,
        },
        showTitle: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    setup(props) {
        const transactionsStore = useTransactionsStore();
        const { selectedCrypto, selectedCryptoAmount, currentStep, markStep, txType, } = storeToRefs(transactionsStore);
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const transactionType = computed(() => {
            if (txType.value === TransactTypes.TransactionType.BUY) {
                return 'Buying';
            }
            return 'Selling';
        });
        const transactHeaderTitle = computed(() => {
            if (props.showTitle) {
                return props.title !== ''
                    ? props.title
                    : `${transactionType.value} ${numberFormat(selectedCryptoAmount.value.amount, 5)} ${selectedCrypto.value.token}`;
            }
            return '';
        });
        const goHome = () => {
            markStep.value = currentStep.value;
            currentStep.value = TransactTypes.TransactSteps.CANCEL_TRANSACTION;
            router.push('/transact');
        };
        const onBackClickListener = () => {
            props.goBack();
        };
        return {
            onKeyPress,
            onBackClickListener,
            selectedCrypto,
            numberFormat,
            goHome,
            transactionType,
            transactHeaderTitle,
        };
    },
});
